import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
import useFeaturePermission from '../hooks/useFeaturePermission';
import { useSelector } from '../redux/store';
import { LoadingScreen } from '../components/loading';

export default function FeatureGuard({ feature, level = 'view', children, fallback }) {
    const { canView, canManage } = useFeaturePermission(feature);
    const permissionsLoading = useSelector((state) => state.permissions.loading);
    const permissions = useSelector((state) => state.permissions.permissions);

    // Wait for permissions to load before making access decisions
    const permissionsLoaded = !permissionsLoading && Object.keys(permissions).length > 0;
    if (!permissionsLoaded) {
        return <LoadingScreen />;
    }

    const hasAccess = level === 'manage' ? canManage : canView;

    if (!hasAccess) {
        if (fallback === 'redirect') {
            return <Navigate to="/dashboard/permission-denied" replace />;
        }
        return fallback || null;
    }

    return <>{children}</>;
}

FeatureGuard.propTypes = {
    feature: PropTypes.string.isRequired,
    level: PropTypes.oneOf(['view', 'manage']),
    children: PropTypes.node.isRequired,
    fallback: PropTypes.node,
};
